<template>
  <router-link
    @click.native="$emit('render-profile')"
    class="team-member-link"
    :to="`/${member.nick}`"
    rel="nofollow"
  >
    <li class="team-member-item">
      <div class="avatar-container">
        <img
          :src="
            player_info.avatar
              ? player_info.avatar
              : require(`../assets/img/defaultAvatar.jpg`)
          "
          alt="avatar"
          class="avatar"
        />
      </div>
      <div class="user-info">
        <p class="user-info__nickname">{{ member.nick }}</p>
        <div class="user-info-container">
          <p class="user-info__latest-results-label">Ostatnie wyniki</p>
          <p class="user-info__latest_results">
            <template v-for="(result, index) in results">
              <span
                :key="index"
                :class="{
                  'text-green': result == 1,
                  'text-red': result == 0
                }"
              >
                {{ result == 1 ? "W" : "L" }}
              </span>
            </template>
          </p>
        </div>
      </div>
      <div class="lvl-icon">
        <img
          :src="getImgUrl(player_info.games.csgo.skill_level_label)"
          alt="lvl"
        />
      </div>
    </li>
  </router-link>
</template>

<script>
import axios from "axios";

export default {
  name: "PlayerCard",
  props: ["member"],
  data() {
    return {
      player_info: {},
      results: [],
      error: ""
    };
  },
  async created() {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.VUE_APP_BEARER_KEY}`
      }
    };
    try {
      const info = await axios.get(
        `https://open.faceit.com/data/v4/players/${this.$props.member.faceit_id}`,
        config
      );
      this.player_info = info.data;

      const results = await axios.get(
        `https://open.faceit.com/data/v4/players/${this.$props.member.faceit_id}/stats/csgo`,
        config
      );
      this.results = results.data.lifetime["Recent Results"];
    } catch (err) {
      this.error = "Wystąpił błąd.";
    }
  },
  methods: {
    getImgUrl(lvl) {
      return require(`../assets/img/lvls/skill_level_${lvl}_svg.svg`);
    }
  }
};
</script>
